<template>
  <SlidingPanel :isPanelOpen="isSlidingPanelOpen" @closePanel="isSlidingPanelOpen = false">
    <template #content>
      <EditUserPanel v-if="currentPanel === 0" :member="currentMember" @close="isSlidingPanelOpen = false"></EditUserPanel>
      <CreateUserPanel v-else @close="isSlidingPanelOpen = false"></CreateUserPanel>
    </template>
  </SlidingPanel>
  <div class="users-wrapper">
    <Header :name="'Liste des utilisateurs'"></Header>
    <div class="header-buttons">
      <Button class="icon icon-left sm primary" icon="bi-plus" :label="'Ajouter un utilisateur'" @click="createUser"></Button>
      <VField class="light m white-background" :placeholder="$t('app.campaign.single.search')" name="search" icon="bi-search" v-model="search.value" @input="(event) => (search.value = event.target.value)" />
    </div>
    <UserTable :search="search" @edit-user="editUser"></UserTable>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { MemberDetails } from '@/types/member.js';

import Header from '@/components/Header.vue';
import Button from '@/components/global/Button.vue';
import VField from '@/components/global/VField.vue';
import SlidingPanel from '@/components/sliding-panel/SlidingPanel.vue';
import EditUserPanel from '@/components/sliding-panel/users/EditUserPanel.vue';
import UserTable from '@/components/global/tables/UserTable.vue';
import CreateUserPanel from '@/components/sliding-panel/users/CreateUserPanel.vue';

const currentPanel = ref(0);
const currentMember: Ref<MemberDetails | null> = ref(null);
const isSlidingPanelOpen = ref(false);
const search = ref({
  value: "",
  searchable: [
    "name",
  ],
});

function createUser() {
  currentPanel.value = 1;
  isSlidingPanelOpen.value = true;
}

function editUser(member: MemberDetails) {
  currentMember.value = member;
  currentPanel.value = 0;
  isSlidingPanelOpen.value = true;
}

function deleteUser(userRow: any) {
  if (!userRow?.id) return;
  //const member = members.value[userRow?.id];
  
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.users-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0 auto;

  width: 900px;
  height: 100%;

  .header-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>